import { useEffect, useState } from "react";

import MainLayout from "./../../Layout/MainLayout";
import CustomCard from "../../Components/CustomCard";

import { sounds, meditation, stories, articles } from "../../Config/data";

import BASEURL from "./../../Config/global";

import "./style.css";
import { Link } from "react-router-dom";
import axios from "axios";

import { useDispatch } from "react-redux";
// import { playAudio } from "../../Store/Slices/AudioSlice";
import { playSound, playAudio, specialsCounter } from "../../Store/Slices/SoundPlayerSlice";
import CustomSearchBar from "../../Components/CustomSearchBar";


import { isMobileSafari, isSafari, isIOS } from 'react-device-detect'
import { userLogout } from "../../Store/Slices/APIs";
import { useTranslation } from "react-i18next";




const Specials = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [specials, setSpecials] = useState([]);


  useEffect(() => {
    dispatch(userLogout())
  }, [])


  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(`${BASEURL}/api/user/specials`);
        if (response.data.error != true) {
          console.log(response)
          setSpecials(response.data.data);
          // console.log(response)
        } else {
          console.log(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  return (
    <>
      <MainLayout title={t("nav.specials")} arrow>
        <div className="row mb-3 specials-banners">
          {
            specials && specials.map((item, index) => (
              item.is_new ? (
                <div class="col-md-4 mb-3" key={index}>
                  <a href={item.link} target={item.is_new ? '_blank' : ''} className="bgRemove">
                    <CustomCard
                      key={index}
                      image={`${item.banner}`}
                      alt={"In The News"}
                      type={"display-banner"}
                    />
                  </a>
                </div>
              ) : (
                <div className="col-md-4 mb-3" key={index}>
                  <Link to={item.link} className="bgRemove">
                    <CustomCard
                      key={index}
                      image={`${item.banner}`}
                      alt={"In The News"}
                      type={"display-banner"}
                    />
                  </Link>
                </div>
              )

            ))
          }
        </div>
      </MainLayout>
    </>
  );
};

export default Specials;
